module.exports = __webpack_public_path__ + "media/images/weather/414_day-96ed6863dc0e7c9951163b3d5744b0f1.png";